import { Grid, } from "@mui/material";
import { CardsStatics, } from "src/Pages/components/CardsStatics";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import WarningIcon from "@mui/icons-material/Warning";
import { FormatMoney } from "src/shared/Utils/FormatMoney";
import { IListBordero } from "src/Contexts/Lancamentos/Contrato/ContratosTypes";
import EventBusyIcon from '@mui/icons-material/EventBusy';

export const CardsMetricsParcelas = ({ data: metrics }: { data: IListBordero['metrics'] }) => {
  return (
    <Grid container spacing={2}>
      <Grid item md={4} xs={12}>
        <CardsStatics
          data={{
            name: "Recebidas",
            value1: {
              value: metrics.recebidas.quantidade.toString(),
              valueSub: `parcelas`,
            },
            value2: {
              value: `R$ ${FormatMoney(metrics.recebidas.valor.toString())}`,
              valueSub: `Entrada da Corretora`,
            },
            icon: (
              <CheckCircleIcon
                color="success"
                sx={{ fontSize: "24px" }}
              />
            ),
          }}
          small
          tooltip="Valor total que a corretora recebeu de comissões de parcelas"
        />
      </Grid>

      <Grid item md={4} xs={12}>
        <CardsStatics
          data={{
            name: "Vencidas",
            value1: {
              value: metrics.vencidas.quantidade.toString(),
              valueSub: `parcelas`,
            },
            value2: {
              value: `R$ ${FormatMoney(metrics.vencidas.valor.toString())}`,
              valueSub: `Entrada não recebida`,
            },
            icon: (
              <EventBusyIcon
                color="error"
                sx={{ fontSize: "24px" }}
              />
            ),
          }}
          small
          tooltip="Valor total que a corretora não recebeu de comissões e já venceu a parcela."
        />
      </Grid>

      <Grid item md={4} xs={12}>
        <CardsStatics
          data={{
            name: "Pendentes",
            value1: {
              value: metrics.pendentes.quantidade.toString(),
              valueSub: `parcelas`,

            },
            value2: {
              value: `R$ ${FormatMoney(metrics.pendentes.valor.toString())}`,
              valueSub: `Entrada prevista`,
            },
            icon: (
              <WarningIcon
                color="disabled"
                sx={{ fontSize: "24px" }}
              />
            ),
          }}
          small
          tooltip="Valor total que a corretora aguarda recebimento dentro do prazo"
        />
      </Grid>
    </Grid>
  );
};

